module.exports = __webpack_public_path__ + "static/img/01.e40c27d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/01.jpg
// module id = caeb
// module chunks = 0